import type { ChatOrderProduct } from './ChatOrderProductCandidatesModal';

interface DeliveryFeeSectionProps {
  product: ChatOrderProduct;
  isSelected: boolean;
  includeDeliveryFee: boolean;
  selectedDeliveryFeeOptionIndex: number;
  formatPrice: (amount: number) => string;
  onToggle: () => void;
  onSelectOption: (index: number) => void;
}

const DeliveryFeeSection = ({
  product,
  isSelected,
  includeDeliveryFee,
  selectedDeliveryFeeOptionIndex,
  formatPrice,
  onToggle,
  onSelectOption,
}: DeliveryFeeSectionProps) => {
  return (
    <div className="delivery-fee-section">
      <div className="delivery-fee-check">
        <input
          type="checkbox"
          id={`delivery-${product._id}`}
          checked={isSelected && includeDeliveryFee}
          onChange={() => onToggle()}
          disabled={!isSelected}
        />
        <label htmlFor={`delivery-${product._id}`}>
          {product.deliveryFeeOptions.length === 1
            ? `배송비 ${formatPrice(product.deliveryFeeOptions[0].fee.amount)} 추가`
            : '배송비 추가'}
        </label>
      </div>
      {isSelected && includeDeliveryFee && product.deliveryFeeOptions.length > 1 && (
        <div className="delivery-fee-options">
          {product.deliveryFeeOptions.map((option, index) => (
            <div
              key={option.name}
              className="delivery-fee-option"
              role="radio"
              aria-checked={selectedDeliveryFeeOptionIndex === index}
              tabIndex={0}
              onClick={() => onSelectOption(index)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelectOption(index); } }}
            >
              <div className={`delivery-fee-radio ${selectedDeliveryFeeOptionIndex === index ? 'selected' : ''}`} />
              <span>{option.name} {formatPrice(option.fee.amount)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DeliveryFeeSection;
